import {
	ADMINHUB_POLICY_CREATE_KEY,
	ADMINHUB_POLICY_UPDATE_KEY,
} from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';

export const isAdminhubPolicyCreateAction = (
	action: Pick<MessageAction, 'key'> & { data?: unknown },
): boolean => action.key === ADMINHUB_POLICY_CREATE_KEY;

export const isAdminhubPolicyUpdateAction = (
	action: Pick<MessageAction, 'key'> & { data?: unknown },
): boolean => action.key === ADMINHUB_POLICY_UPDATE_KEY;
